<template>
  <div>
    <open-fund-header />
    <div class="r-text-intro">אפשר לחלום!</div>
    <div class="r-text-headline-paragraph">
      <div>
        <span>מה היית עושה עם </span>
        <span class="r-text-bold">{{ this.formatAmountWithFraction(compoundInterest, 0) }} ₪</span>
      </div>
      <div>
        <span> בעוד </span>
        <span class="r-text-bold">{{ period }} שנים</span>
        <span>?</span>
      </div>
    </div>
    <select-buttons :options="options" />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters, mapState } from 'vuex';
import TrackedPage from '@/mixins/TrackedPage';
import Segment from '@/Segment';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';
import SelectButtons from '@/components/base/SelectButtons';
import MoneyFormat from '@/mixins/MoneyFormat';

export default {
  name: 'Dreams',
  components: { SelectButtons, OpenFundHeader },
  mixins: [TrackedPage, MoneyFormat],
  computed: {
    ...mapState('lightup/projection', ['monthlyDeposit', 'period']),
    ...mapGetters('lightup/projection', ['compoundInterest']),
    options() {
      return [
        {
          img: require('@/assets/lightup/gift.svg'),
          label: 'משהו לעצמי',
          action: this.next,
        },
        {
          img: require('@/assets/lightup/kids.svg'),
          label: 'משהו לילדים',
          action: this.next,
        },
        {
          img: require('@/assets/lightup/house.svg'),
          label: 'משהו לבית',
          action: this.next,
        },
        {
          img: require('@/assets/lightup/pension.svg'),
          label: 'מחכה עם זה לפנסיה',
          action: this.next,
        },
        {
          img: require('@/assets/lightup/good-question.svg'),
          label: 'שאלה טובה...',
          action: this.next,
        },
      ];
    },
  },
  methods: {
    async next(selectedOption) {
      Segment.trackUserInteraction('Saving_DreamClicked', { selection: selectedOption.label });
      await this.$router.push('coffee');
    },
  },
};
</script>
